// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Sora:wght@100..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AssetManagement_Heading__uRRAQ {
  font-weight: 600;
  font-size: 28px;
  font-family: "Sora";
  text-align: center;
  margin: 0px;
  margin-top: 10px;
  /* margin-bottom: 40px; */
  /* text-decoration: underline; */
}

.ant-table-wrapper .ant-table-thead tr th {
  font-weight: bold;
  color: blue;
  background-color: transparent;
  font-family: "Noto Sans";
  border: 0px;
}
.ant-table-wrapper .AssetManagement_History__XJ0nW .AssetManagement_ant-table-wrapper__aweAp {
  clear: both;
  width: 600px;
}
.ant-table-wrapper .ant-table-tbody tr:nth-child(even) {
  background-color: #FFF7FC;
}
.ant-table-wrapper .ant-table-tbody tr:nth-child(odd) {
  background-color: white;
}

.ant-table-wrapper .ant-table-tbody tr td {
  font-family: "Roboto";
  border: 0px;
}

.AssetManagement_PModal__p00Oa {
  width: 850px;
}

.AssetManagement_Type__JMSpR {
  border-radius: 9px;
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: blue;
  border-radius: 10px;
}

.AssetManagement_label__IThyA {
  font-weight: 600;
  font-size: 16px;
  padding-right: 5px;
  color: #8576FF;
}

.AssetManagement_value__A6IY8 {
  font-size: 16px;
}

p:hover {
  color: blue; /* Change text color to blue on hover */
  cursor: pointer; /* Change cursor to pointer on hover */
}`, "",{"version":3,"sources":["webpack://./src/components/AssetManagement.module.scss"],"names":[],"mappings":"AAGA;EAEI,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,gCAAA;AAAJ;;AAMM;EACE,iBAAA;EACA,WAAA;EACA,6BAAA;EACA,wBAAA;EACA,WAAA;AAHR;AAQE;EACE,WAAA;EACA,YAAA;AANJ;AASI;EACE,yBAAA;AAPN;AASI;EACE,uBAAA;AAPN;;AAeM;EACE,qBAAA;EACA,WAAA;AAZR;;AAkBA;EACE,YAAA;AAfF;;AAmBA;EAGE,kBAAA;AAlBF;;AAoBA;EACI,UAAA;AAjBJ;;AAoBE;EACE,mBAAA;AAjBJ;;AAoBE;EACE,gBAAA;EACA,mBAAA;AAjBJ;;AAqBE;EAEE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AAnBJ;;AAsBE;EAEE,eAAA;AApBJ;;AAuBE;EACE,WAAA,EAAA,uCAAA;EACA,eAAA,EAAA,sCAAA;AApBJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap');\r\n@import url('https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap');\r\n@import url('https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Sora:wght@100..800&display=swap');\r\n.Heading\r\n{\r\n    font-weight: 600;\r\n    font-size: 28px;\r\n    font-family: \"Sora\";\r\n    text-align: center;\r\n    margin: 0px;\r\n    margin-top: 10px;\r\n    /* margin-bottom: 40px; */\r\n    /* text-decoration: underline; */\r\n}\r\n\r\n:global(.ant-table-wrapper) {\r\n  :global(.ant-table-thead) {\r\n    tr {\r\n      th {\r\n        font-weight: bold;\r\n        color: blue;\r\n        background-color: transparent;\r\n        font-family: \"Noto Sans\";\r\n        border:0px;\r\n      }\r\n    }\r\n  }\r\n  .History{\r\n  .ant-table-wrapper {\r\n    clear: both;\r\n    width: 600px;\r\n}}\r\n  :global(.ant-table-tbody) {\r\n    tr:nth-child(even) {\r\n      background-color: #FFF7FC; \r\n    }\r\n    tr:nth-child(odd) {\r\n      background-color: white;\r\n    }\r\n  }\r\n}\r\n\r\n:global(.ant-table-wrapper) {\r\n  :global(.ant-table-tbody) {\r\n    tr {\r\n      td {\r\n        font-family: \"Roboto\";\r\n        border: 0px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.PModal {\r\n  width: 850px;\r\n  \r\n}\r\n\r\n.Type\r\n{\r\n  \r\n  border-radius: 9px;\r\n}\r\n::-webkit-scrollbar {\r\n    width: 5px;\r\n  }\r\n\r\n  ::-webkit-scrollbar-track {\r\n    background: #f1f1f1;\r\n  }\r\n\r\n  ::-webkit-scrollbar-thumb {\r\n    background: blue;\r\n    border-radius: 10px;\r\n  }\r\n    \r\n\r\n  .label\r\n  {\r\n    font-weight: 600;\r\n    font-size: 16px;\r\n    padding-right: 5px;\r\n    color: #8576FF;\r\n  }\r\n\r\n  .value\r\n  {\r\n    font-size: 16px;\r\n  }\r\n\r\n  p:hover {\r\n    color: blue; /* Change text color to blue on hover */\r\n    cursor: pointer; /* Change cursor to pointer on hover */\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Heading": `AssetManagement_Heading__uRRAQ`,
	"History": `AssetManagement_History__XJ0nW`,
	"ant-table-wrapper": `AssetManagement_ant-table-wrapper__aweAp`,
	"PModal": `AssetManagement_PModal__p00Oa`,
	"Type": `AssetManagement_Type__JMSpR`,
	"label": `AssetManagement_label__IThyA`,
	"value": `AssetManagement_value__A6IY8`
};
export default ___CSS_LOADER_EXPORT___;
